module.exports = __webpack_public_path__ + "img/gfmlogo.c96542f0.png";